// Pure resolution of a zone/home route's params against the homes the current
// session was actually seeded with. Used by ZoneRoute / HomeRoute to decide
// whether a /zone/... or /property/... URL names something this account owns.
//
// SECURITY: the URL is untrusted — a bookmarked or hand-crafted link, or a stale
// one left by another account on a shared browser. Validating against the seeded
// homeList (the same set the dashboard's home selection trusts) means a URL for a
// home or zone this session does not own resolves to null, and the caller
// redirects to the Property screen rather than handing an unknown id/tuple to the
// darwin_core selectors.
//
// Params arrive from the router as decoded STRINGS; a zone's zoneId holds the real
// typed tuple ([prtId, endpointId] with a numeric endpointId). Matching is done on
// the string forms, but the matched zone's own zoneId is returned so downstream
// selectors receive the correctly-typed tuple, never the string-coerced params.

// The zone object from the seeded homes matching (homeId, prtId, endpointId), or
// null if the home is not owned, the zone tuple is not present, or the zone is
// malformed. A malformed zone has no [prtId, endpointId] array — darwin_core's
// parseZone yields exactly that for an unrecognised type — so it can never be a
// valid navigation target.
export function findAccountZone(homes, homeId, prtId, endpointId) {
  const home = findAccountHome(homes, homeId);
  if (!home) {
    return null;
  }
  const zones = Array.isArray(home.zones) ? home.zones : [];
  const zone = zones.find(
    (z) =>
      Array.isArray(z?.zoneId) &&
      String(z.zoneId[0]) === String(prtId) &&
      String(z.zoneId[1]) === String(endpointId),
  );
  return zone ?? null;
}

// The home object from the seeded homes matching homeId, or null if not owned.
export function findAccountHome(homes, homeId) {
  if (!Array.isArray(homes)) {
    return null;
  }
  return homes.find((home) => home?.id === homeId) ?? null;
}
